module.exports = __webpack_public_path__ + "img/team_blue.4d06de19.svg";